export const LOCAL_STORAGE_TOKEN_KEY = 'token';
export const LOCAL_STORAGE_MASTER_RESTAURANT_TOKEN_KEY =
  'master_restaurant_token';
export const LOCAL_STORAGE_SIDEBAR_OPEN_KEY = 'sidebar_open';
export const SESSION_STORAGE_INGREDIENT_QUANTITY_INPUT_TYPE_KEY =
  'ingredient_input_type';
export const TRACK_TIMER_DURATION_LOCAL_STORAGE_KEY = 'track_timer_duration';
